import React from 'react'
import PropTypes from 'prop-types'
import {
  Description,
  StyledContainer,
  StyledHr,
  Title,
  TitleAndRecommendationWrapper,
  TitleWrapper,
  Recommendation,
} from './component.styles'

const RequiredGoal = ({
  dataTestId,
  children,
  description,
  recommendation,
  title,
}) => {
  return (
    <StyledContainer dataTestId={dataTestId}>
      <TitleWrapper>
        <TitleAndRecommendationWrapper>
          <Title>{title}</Title>
          {recommendation && <Recommendation>{recommendation}</Recommendation>}
        </TitleAndRecommendationWrapper>
        <StyledHr />
        <Description>{description}</Description>
      </TitleWrapper>
      {children}
    </StyledContainer>
  )
}

RequiredGoal.propTypes = {
  children: PropTypes.node,
  dataTestId: PropTypes.string,
  description: PropTypes.string,
  recommendation: PropTypes.string,
  title: PropTypes.string,
}

export default RequiredGoal
